import { RouterModule } from '@angular/router';
import { IconModule } from './../icon/icon.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TabComponent } from "./tab.component";
import { TabContentComponent } from "./tab-content/tab-content.component";

@NgModule({
	declarations: [TabComponent, TabContentComponent],
	imports: [CommonModule, IconModule, RouterModule],
	exports: [TabComponent, TabContentComponent]
})
export class TabModule {}
